import { Box, BoxProps } from "@mui/material";
import { HButton, HResult, HResultProps, ResultVariantType } from "@ob/core";
import { FC, ReactNode } from "react";
import { useIntl } from "react-intl";

export type FeedbackPageProps = {
  message?: string;
  title?: string;
  hideRefreshPageButton?: boolean;
  severity?: ResultVariantType;
  boxProps?: BoxProps;
  buttonText?: string;
  resultProps?: HResultProps;
  onButtonClick?: () => void;
};
export const FeedbackPage: FC<FeedbackPageProps & { children?: ReactNode }> = ({
  message,
  boxProps,
  title,
  severity = "warning",
  buttonText,
  onButtonClick,
  children,
  hideRefreshPageButton,
  resultProps,
}) => {
  const { formatMessage } = useIntl();
  const handleRefresh = () => {
    window.location.reload();
  };
  return (
    <Box
      display={"flex"}
      justifyContent="center"
      alignItems="center"
      flexDirection="column"
      width="100%"
      sx={{
        margin: "auto",
        maxWidth: 359,
        px: 5,
      }}
      {...boxProps}
    >
      {!children ? (
        <>
          <HResult
            name=""
            resultVariant={severity}
            text={
              title || formatMessage({ id: "errorMessages.errorPageTitle" })
            }
            labelSecondary={
              message || formatMessage({ id: "errorMessages.errorPageMessage" })
            }
            {...resultProps}
            wrapperProps={{
              ...resultProps?.wrapperProps,
              sx: {
                mt: { sm: 0, md: 0 },
                ...resultProps?.wrapperProps?.sx,
              },
            }}
          />
          {!hideRefreshPageButton && (
            <Box my={7} width="100%" justifyContent="center" display="flex">
              <HButton
                variant="primary"
                fullWidth
                onClick={onButtonClick || handleRefresh}
                sx={{ maxWidth: { xs: "100%", sm: 294 } }}
              >
                {buttonText ||
                  formatMessage({ id: "errorMessages.refreshPage" })}
              </HButton>
            </Box>
          )}
        </>
      ) : (
        <>{children}</>
      )}
    </Box>
  );
};
